<template>
  <router-view />
</template>

<script>
import { mapMutations } from 'vuex';
import '@/assets/style.css';

export default {
  methods: {
    ...mapMutations('theme', ['setDarkMode']),
  },
  mounted() {
    // --- Restore theme colors ---
    let user = localStorage.getItem('user');
    user = user ? JSON.parse(user) : {};

    this.$vuetify.theme.themes.light.primary   = user.theme_primary_color || '#f87676';
    this.$vuetify.theme.themes.dark.primary    = user.theme_primary_color || '#f87676';
    this.$vuetify.theme.themes.light.secondary = user.theme_button_color  || '#30384d';
    this.$vuetify.theme.themes.dark.secondary  = user.theme_button_color  || '#30384d';

    // Force light mode
    this.$vuetify.theme.dark = false;
    this.setDarkMode(false);

    // Sync CSS brand variations to chosen primary color
    const primary = user.theme_primary_color || '#f87676';
    document.documentElement.style.setProperty('--brand', primary);
    document.documentElement.style.setProperty('--brand-lt', `${primary}1A`);
    document.documentElement.style.setProperty('--brand-glow', `${primary}2E`);

    // Sync button color CSS variable
    const btnColor = user.theme_button_color || '#30384d';
    document.documentElement.style.setProperty('--btn-color', btnColor);
  },
}
</script>

<style>
/* Table hover - premium */
.v-data-table tbody tr:hover td {
  background-color: var(--surface2) !important;
  cursor: pointer;
}

/* Premium table styles */
.custom-premium-table { background: var(--surface) !important; }
.custom-premium-table thead th {
  background-color: var(--surface2) !important;
  color: var(--tx4) !important;
  text-transform: uppercase;
  font-size: 10.5px !important;
  letter-spacing: 0.07em;
  font-weight: 700 !important;
  border-bottom: 1px solid var(--border) !important;
  white-space: nowrap;
}
.custom-premium-table tbody td {
  border-bottom: 1px solid var(--border2) !important;
  padding: 14px 16px !important;
  color: var(--tx2) !important;
}

/* Status utilities */
.border-soft   { border: 1px solid var(--border) !important; }
.border-dashed { border: 1px dashed var(--border) !important; }


/* Custom society-admin sidebar sets its own background on .premium-nav-drawer */
.premium-nav-drawer.v-navigation-drawer {
  background: var(--sb, #080d1a) !important;
}
.light-sidebar.premium-nav-drawer.v-navigation-drawer {
  background: #ffffff !important;
}

/* Main content background */
.v-main { background: var(--bg) !important; }
</style>